

import events from 'actions/events'
import eventNames from './eventNames'
import Actions from './Actions'
import { uuid } from 'lib/helpers';

class Tracking extends Actions{
    static sessionTrackingKey = 'nil-session-tracking-id'
    static deviceTrackingKey = 'nil-device-tracking-id'

    static sessionID = null
    static deviceID = null
    static instanceID = null

    static start(){
        const formNames = [
            eventNames.componentDidSubmit.filters,
            eventNames.componentDidSubmit.collectInformation,
            eventNames.componentDidSubmit.confirmation,
            eventNames.componentDidSubmit.timeSlots,
        ]
        for (let formName of formNames) {
            events.on(formName, () => {                
                const formNameUpdated = formName.replace('.componentDidSubmit', '');
                
                const  request = this.client.organizations.formCompletion.create({
                    sessionID: Tracking.sessionID,
                    deviceID: Tracking.deviceID,
                    instanceID: Tracking.instanceID,
                    name: formNameUpdated,
                })    
                
                request.then(() => {
                    if(formNameUpdated === "Confirmation" && window.onCompleteSnippet){
                        window.onCompleteSnippet()
                    }
                })
                
                return request;

            })
        }

        
        let deviceID = localStorage.getItem(this.deviceTrackingKey)
        if(!deviceID){
            const id = uuid()
            localStorage.setItem(this.deviceTrackingKey, id)
            deviceID = id
        }

        this.deviceID = deviceID


        
        
        let sessionID = sessionStorage.getItem(this.sessionTrackingKey)
        if(!sessionID){
            const id = uuid()
            sessionStorage.setItem(this.sessionTrackingKey, id)
            sessionID = id
        }

        this.sessionID = sessionID

        if(!this.instanceID){
            let instanceID = uuid()
            this.instanceID = instanceID
        } 
    }
    
    static reset(){
        let instanceID = uuid()
        this.instanceID = instanceID
    }
}

export default Tracking


// WEBPACK FOOTER //
// ./actions/TrackingActions.js